import { z } from "zod";

export const journalEntryLineDataSchema = z.object({
    lineOrder: z.coerce.number().default(0),
    accountName: z.string().optional(),
    accountId: z.string().default(""),
    accountCode: z.coerce.number().optional(),
    description: z.string().default(""),
    classNames: z.string().optional(),
    classIds: z.array(z.string()).optional(),
    counterpartyId: z.string().uuid().nullable().optional(),
    debitAmount: z.coerce.number().nullable().default(null),
    creditAmount: z.coerce.number().nullable().default(null),
});

export const journalEntryMetadataSchema = z.object({
    date: z.coerce.date().optional(),
    dateOnly: z.string().nullable().optional(),
    referenceNumber: z.string().optional(),
    excludeFrom1099: z.boolean().optional(),
    reversedAt: z.coerce.date().nullable().optional(),
    memo: z.string().nullable().optional(),
    recurringRule: z
        .object({
            period: z.string().optional(),
            interval: z.number().optional(),
            weekDay: z.number().nullable().optional(),
            month: z.number().nullable().optional(),
            dateOfMonth: z.number().nullable().optional(),
            monthRecurrenceType: z.string().nullable().optional(),
            endDate: z.string().nullable().optional(),
            maxOccurrenceCount: z.number().nullable().optional(),
        })
        .nullable()
        .optional(),
    financialDocumentLinks: z
        .array(
            z.object({
                financialDocumentId: z.number(),
                financialDocument: z
                    .object({
                        id: z.number(),
                        fileName: z.string(),
                    })
                    .optional(),
            }),
        )
        .optional(),
});
